<template>
    <b-modal
        id="teamchat-users"
        :ok-title="$t('team-chats.add-people')"
        :title="$t('team-chats.add-people-group')"
        centered
        footer-class="justify-content-end"
        header-close-variant="light"
        ok-only
        @ok="addSelectedUsers"
    >
        <p>{{ $t("team-chats.select-people-group") }}</p>

        <b-input-group class="input-group-merge w-100 mr-1 mb-2 round">
            <b-form-input v-model="searchQuery" :placeholder="$t('team-chats.search-people')" />
            <b-input-group-append is-text>
                <div class="saysimple-icon search" />
            </b-input-group-append>
        </b-input-group>

        <div v-if="selectedList.length > 0" class="scroll-area-x scroll-container auto mb-2">
            <ul class="selected-users d-flex p-0">
                <li
                    v-for="user in selectedList"
                    :key="user.id"
                    class="d-flex align-items-center flex-column ml-0 mx-50 my-50"
                >
                    <b-avatar
                        :src="user.pictureUrl"
                        :text="resolveInitials(user.name)"
                        badge
                        badge-offset="-3px"
                        badge-top
                        badge-variant="dark"
                        class="cursor-pointer badge-minimal round-large badge-close"
                        size="34"
                        variant="info"
                    >
                        <template #badge>
                            <b-link @click="removeSelection(user.id)">&#10799;</b-link>
                        </template>
                    </b-avatar>
                    {{ user.name.split(" ").slice(0, 1).join(" ") }}
                </li>
            </ul>
        </div>

        <div class="list-group scroll-area scroll-container auto">
            <b-overlay>
                <b-form-group>
                    <b-form-checkbox
                        v-for="user in filteredList"
                        :key="user.id"
                        v-model="selectedUsers"
                        :name="String(user.id)"
                        :value="user.id"
                        class="round-extra-large"
                    >
                        <b-avatar
                            :badge-variant="resolveUserStatus(user.status)"
                            :src="user.pictureUrl"
                            :text="resolveInitials(user.name)"
                            badge
                            badge-offset="-3px"
                            class="mr-1 cursor-pointer badge-minimal round-large"
                            size="34"
                            variant="info"
                        />
                        {{ user.name }}
                    </b-form-checkbox>
                </b-form-group>
            </b-overlay>
        </div>
    </b-modal>
</template>

<script>
import {
    BAvatar,
    BBadge,
    BButton,
    BCol,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BInputGroup,
    BInputGroupAppend,
    BLink,
    BNav,
    BNavItem,
    BOverlay,
    BRow,
    VBHover,
    VBModal,
} from "bootstrap-vue";
import TeamUserItem from "./team-chat-left-sidebar/teamUserItem.vue";
import { resolveInitials, resolveUserStatus } from "@/utils/users";
import { ref } from "@vue/composition-api";
import { without } from "lodash";

export default {
    components: {
        BNav,
        BNavItem,
        BAvatar,
        BButton,
        BLink,
        BRow,
        BCol,
        BOverlay,
        BBadge,
        BInputGroup,
        BInputGroupAppend,
        BFormRadioGroup,
        BFormInput,
        BFormCheckbox,
        BFormGroup,
        TeamUserItem,
    },
    directives: {
        "b-hover": VBHover,
        "b-modal": VBModal,
    },
    props: {
        users: Array,
    },
    computed: {
        filteredList() {
            return this.users.filter((user) => {
                return user?.name?.toLowerCase().includes(this.searchQuery.toLowerCase()) || false;
            });
        },
        selectedList() {
            return this.users.filter((user) => {
                return this.selectedUsers.includes(user.id);
            });
        },
    },
    methods: {
        handleHover(hovered) {
            this.isHovered = hovered;
        },
        removeSelection(userId) {
            this.selectedUsers = without(this.selectedUsers, userId);
        },
    },
    setup(props, context) {
        const searchQuery = ref("");
        const selectedUsers = ref([]);

        const addSelectedUsers = () => {
            context.emit("add-selected-users", selectedUsers.value);
            selectedUsers.value = [];
        };

        return {
            resolveUserStatus,
            resolveInitials,
            addSelectedUsers,
            selectedUsers,
            searchQuery,
        };
    },
};
</script>

<style lang="scss">
@import "~@/assets/scss/modules/team-chat/teamChatUsersModal.scss";
</style>
